import script from "./ProfileHashtags.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileHashtags.vue?vue&type=script&setup=true&lang=js"

import "./ProfileHashtags.vue?vue&type=style&index=0&id=13d7fb7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d7fb7a"]])

export default __exports__